module.exports = __webpack_public_path__ + "static/media/pickup.aa6e7468.svg";